import { toastError } from '@components/Toast';

import * as actionTypes from '@store/supplier/action-types';

import ApiClient from '@lib/apiClient';

export const fetchAllSuppliers = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_ALL_SUPPLIER_TYPE_REQUEST });
		const response = await ApiClient.GET('getAllSupliers');
		dispatch({
			type: actionTypes.FETCH_ALL_SUPPLIER_TYPE_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_ALL_SUPPLIER_TYPE_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSuplierCategory = (type) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_SUPPLIER_CATEGORY_TYPE_REQUEST });
		const response = await ApiClient.GET('getSuplierCategory', type);
		dispatch({
			type: actionTypes.FETCH_SUPPLIER_CATEGORY_TYPE_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_SUPPLIER_CATEGORY_TYPE_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchAllTags =
	(term = '', type) =>
	async (dispatch) => {
		try {
			dispatch({ type: actionTypes.FETCH_STRENGTH_REQUEST });
			let params = `?page=0&size=1000&type=${type}&search=${term}`;
			const response = await ApiClient.GET('getAllTags', params);
			dispatch({
				type: actionTypes.FETCH_STRENGTH_SUCCESS,
				payload: { type: type, data: response.data }
			});
		} catch (error) {
			dispatch({ type: actionTypes.FETCH_STRENGTH_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

export const fetchAllCountry = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_COUNTRY_REQUEST });
		const response = await ApiClient.GET('getAllCountry');
		dispatch({
			type: actionTypes.FETCH_COUNTRY_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_COUNTRY_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSupplierCityByCountry = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_CITY_REQUEST });
		if (id) {
			const response = await ApiClient.GET('getSupplierCityByCountry', id);
			dispatch({
				type: actionTypes.FETCH_CITY_SUCCESS,
				payload: response.data
			});
		} else {
			dispatch({
				type: actionTypes.FETCH_CITY_SUCCESS,
				payload: []
			});
		}
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_CITY_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSupplierDetails = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_SUPPLIER_DETAILS_REQUEST });
		const response = await ApiClient.GET('getSuppliersDetails', id);
		dispatch({
			type: actionTypes.FETCH_SUPPLIER_DETAILS_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_SUPPLLIER_DETAILS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSuppliersPhotoGallarey = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_SUPPLIER_PHOTO_GALLAREY_REQUEST });
		const response = await ApiClient.GET('getSuppliersPhotoGallarey', id);
		dispatch({
			type: actionTypes.FETCH_SUPPLIER_PHOTO_GALLAREY_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_SUPPLIER_PHOTO_GALLAREY_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSuppliersCertificates = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_SUPPLIER_CERTIFICATES_REQUEST });
		const response = await ApiClient.GET('supplierAction', `${id}/certificates`);
		dispatch({
			type: actionTypes.FETCH_SUPPLIER_CERTIFICATES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_SUPPLIER_CERTIFICATES_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSupplierReviewSummaries = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_SUPPLIER_REVIEW_SUMMARIES_REQUEST });
		const response = await ApiClient.GET('getSuppliersReviewSummaries', id);
		dispatch({
			type: actionTypes.FETCH_SUPPLIER_REVIEW_SUMMARIES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_SUPPLIER_REVIEW_SUMMARIES_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSupplierReviews =
	(id, page = 0, size = 3) =>
	async (dispatch) => {
		try {
			dispatch({ type: actionTypes.FETCH_SUPPLIER_REVIEWS_REQUEST });
			let params = `${id}?page=${page}&size=${size}`;
			const response = await ApiClient.GET('getSuppliersReviews', params);
			dispatch({
				type:
					page > 0
						? actionTypes.FETCH_MORE_USERS_REVIEWS_SUCCESS
						: actionTypes.FETCH_SUPPLIER_REVIEWS_SUCCESS,
				payload: response.data
			});
		} catch (error) {
			dispatch({ type: actionTypes.FETCH_SUPPLIER_REVIEWS_FAILURE });
			dispatch({ type: actionTypes.FETCH_MORE_USERS_REVIEWS_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

const buildFilterParams = (filterParams) => {
	const results = {};
	for (const [key, value] of Object.entries(filterParams)) {
		if (value) {
			if (Array.isArray(value) && value.length !== 0) {
				results[key] = value;
			}
			if (!Array.isArray(value)) {
				results[key] = value;
			}
		}
	}
	return results;
};

export const fetchMaterialsOnSelectImage = (moodboardId, id) => async (dispatch) => {
	// dispatch(openLoader());
	await ApiClient.GET('moodboardAction', `${moodboardId}/material-search/${id}`)
		.then(({ data }) => {
			// dispatch(closeLoader());
			if (data) {
				dispatch({
					type: actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_SUCCESS,
					payload: { data: data }
				});
			}
		})
		.catch(({ response }) => {
			// dispatch(closeLoader());
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Request was unsuccessful.');
			}
		});
};

export const fetchAllSuppliersMaterials =
	(page = 0, size = 20, type, sort, filterParams = {}, requestFrom, queryString, trimsQueryParams) =>
	async (dispatch) => {
		try {
			dispatch({ type: actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_REQUEST });
			const params = { page, size, supplierType: type, ...buildFilterParams(filterParams), sort };
			delete params.page;
			delete params.sort;
			delete params.size;
			let url = 'getSuppliersMaterials';
			if (requestFrom === 'MATERIAL_LIST' && type === 'GARMENTS') {
				url = 'fetchGarments';
				params.sort = 'id,desc';
			}

			const response =
				type === 'GARMENTS'
					? await ApiClient.GET(url, params)
					: await ApiClient.POST(
							url,
							{ ...params },
							type === 'FABRIC' ? queryString : trimsQueryParams
						);

			dispatch({
				type:
					page > 0 && !params.search
						? actionTypes.FETCH_MORE_ALL_SUPPLIERS_MATERIALS_SUCCESS
						: page > 0 && params.search
							? actionTypes.FETCH_MORE_ALL_SUPPLIERS_MATERIALS_SUCCESS
							: actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_SUCCESS,
				payload: {
					...response.data,
					data: response?.data.data,
					hasNext: response?.data.currentPage + 1 < response?.data.totalPages
				}
			});
			if (
				(response && !!filterParams.search) ||
				!!filterParams.supplierReferenceNumber ||
				!!filterParams.nitexReferenceNumber
			) {
				dispatch(updateSearchResultForFabric(response?.data?.data[0]?.materialId, true));
				dispatch(getSearchValue(''));
			}
		} catch (error) {
			dispatch(updateSearchResultForFabric(null, false));
			dispatch({ type: actionTypes.FETCH_ALL_SUPPLIERS_MATERIALS_FAILURE });
			if (error.message) {
				// toastError(error.message);
			} else {
				// toastError('Something went wrong! Please try again.');
			}
		}
	};

export const fetchSuppliersMaterialList =
	(page = 0, size = 20, supplierId, sort) =>
	async (dispatch) => {
		try {
			dispatch({ type: actionTypes.FETCH_SUPPLIER_MATERIAL_LIST_REQUEST });
			let params = `${supplierId}?page=${page}&size=${size}&sort=${sort}`;
			const response = await ApiClient.GET('getSuppliersMaterialList', params);
			dispatch({
				type:
					page > 0
						? actionTypes.FETCH_MORE_SUPPLIER_MATERIAL_LIST_SUCCESS
						: actionTypes.FETCH_SUPPLIER_MATERIAL_LIST_SUCCESS,
				payload: {
					...response.data,
					data: response?.data.data,
					hasNext: !(response?.data.currentPage + 1 >= response?.data.totalPages)
				}
			});
		} catch (error) {
			dispatch({ type: actionTypes.FETCH_SUPPLIER_MATERIAL_LIST_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

export const fetchSupplier =
	(page = 0, size = 20, term = '', materialType, sort) =>
	async (dispatch) => {
		try {
			let params = `?page=${page}&size=${size}&name=${term}&materialType=${materialType}&sort=${sort}`;
			const response = await ApiClient.GET('getSupplier', params);
			dispatch({
				type: actionTypes.FETCH_SUPPLIER_SEARCH_SUCCESS,
				payload: {
					...response.data,
					data: response?.data.data.map((item) => {
						return {
							...item,
							value: item.name,
							label: item.name
						};
					})
				}
			});
		} catch (error) {
			dispatch({ type: actionTypes.FETCH_SUPPLIER_SEARCH_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

export const fetchAllSuppliersList =
	(page = 0, size = 20, filterParams) =>
	async (dispatch) => {
		try {
			const params = { page, size, ...buildFilterParams(filterParams) };
			const response = await ApiClient.GET('getSuppliersList', params);
			dispatch({
				type:
					page > 0
						? actionTypes.FETCH_MORE_SUPPLIER_LIST_SUCCESS
						: actionTypes.FETCH_SUPPLIER_LIST_SUCCESS,
				payload: {
					...response.data,
					data: response?.data.data,
					hasNext: response?.data.currentPage + 1 < response?.data.totalPages
				}
			});
		} catch (error) {
			dispatch({ type: actionTypes.FETCH_SUPPLIER_LIST_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

export const updateSearchResultForFabric = (materialId, isSuccess) => (dispatch) => {
	dispatch({ type: actionTypes.FETCH_FABRIC_SEARCH_SUCCESS, payload: { materialId, isSuccess } });
};

export const getSearchValue = (value) => (dispatch) => {
	dispatch({ type: actionTypes.GET_SEARCH_VALUE, payload: value });
};

export const setIsDescriptionSearchOpen = (value) => (dispatch) => {
	dispatch({ type: actionTypes.IS_DESCRIPTION_SEARCH_OPEN, payload: value });
};

export const setDescriptionSearchText = (value) => (dispatch) => {
	dispatch({ type: actionTypes.GET_DESCRIPTION_SEARCH_TEXT, payload: value });
};
